import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { ChevronDown } from "lucide-react";

// Shared public feature routes — the single source of truth for the top-nav
// "Features" menu and the footer links (keeps them crawlable + in sync).
export const FEATURE_LINKS = [
  { slug: "ambient-scribe", label: "Ambient visit scribe" },
  { slug: "claims-appeals", label: "Claims & appeals engine" },
  { slug: "care-circle", label: "Unified care circle" },
];

// Persistent top nav for the marketing pages. Renders the row only (no outer
// container) so each page can place it inside its own navy header.
export function MarketingNav() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  return (
    <div className="flex items-center justify-between py-6">
      <Link to="/" data-testid="nav-home" aria-label="KinBridge Health home"><Logo className="h-8" onDark testid="brand-name" /></Link>
      <div className="flex items-center gap-5 sm:gap-7">
        <div className="relative">
          <button
            data-testid="nav-features"
            onClick={() => setOpen((v) => !v)}
            aria-expanded={open}
            aria-haspopup="true"
            className="inline-flex items-center gap-1 text-white text-sm font-semibold hover:text-mint transition-colors"
          >
            Features <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
          </button>
          {open && (
            <>
              <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} data-testid="nav-features-backdrop" />
              <div className="absolute right-0 mt-2 w-64 bg-white border border-line rounded-xl shadow-lg p-2 z-50">
                {FEATURE_LINKS.map((f) => (
                  <Link
                    key={f.slug}
                    to={`/features/${f.slug}`}
                    data-testid={`nav-feature-${f.slug}`}
                    onClick={() => setOpen(false)}
                    className="block px-3 py-2 rounded-lg text-sm text-ink hover:bg-mint-tint transition-colors"
                  >
                    {f.label}
                  </Link>
                ))}
              </div>
            </>
          )}
        </div>
        <button
          onClick={() => navigate(user ? "/app" : "/login")}
          data-testid="nav-signin"
          className="text-white text-sm font-semibold hover:text-mint transition-colors"
        >
          {user ? "Open app →" : "Sign in →"}
        </button>
      </div>
    </div>
  );
}
